import React,{useState,useEffect} from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import PageLogo from '../assets/img/bicpavilion.png';
import Logo from './Logo';
import { NavLink } from 'react-router-dom';
import { HashLink, NavHashLink } from 'react-router-hash-link';
import { useLocation } from "react-router-dom";

import { styled } from '@mui/material/styles';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { BorderStyle } from "@mui/icons-material";

const RedButton = styled(Button)(({ theme }) => ({
  '&':{
    color: 'gray',
    borderRadius: 0,
  },  
  '&.active': {
    color: '#e30613',
    border: '1px solid rgba(255, 0, 17, 0.5)',
    borderStyle: 'hidden hidden solid hidden' ,
  },
 
 
}));

const pages = ['Home', 'All Pavilions', 'Launch My Pavilion','HowTo Videos','Privacy Policy','Contact'];
const links = ['/', '/#allpavilions', '/plans','https://www.youtube.com/channel/UCpvImeYUgu-UAHyjRKDaPTA','/privacypolicy','/contact'];

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function NaviBar() {
  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [isIconClicked, setIsIconClicked] = useState(true);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

 const handleDarkMode = (event) => {
    setIsIconClicked(!isIconClicked);

    const thm = document.documentElement.getAttribute("data-bs-theme");
    const appId = document.getElementById('app-theme');
    const thm2 = appId.getAttribute('data-bs-theme');
    const thmToggler = event.currentTarget;
    const theme = localStorage.getItem("data-bs-theme");
    // thmToggler.innerHTML='<small>{theme}</small>';

    if (thm2 === 'light') {
      appId.setAttribute('data-bs-theme', 'dark');
      document.documentElement.setAttribute("data-bs-theme", "dark");
      localStorage.setItem("data-bs-theme", "dark");

      // thmToggler.innerHTML='<small>LIGHT MODE<small>';
    } else {
      appId.setAttribute('data-bs-theme', 'light');
      document.documentElement.setAttribute("data-bs-theme", "light");
      localStorage.setItem("data-bs-theme", "light");
      //  thmToggler.innerHTML='<small>DARK MODE</small>';
    }

  }

  return (
    <AppBar position="sticky" className='bg-toggle pt-3 pb-2' sx={{color:'#e30613'}}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ flexGrow: 1,display: { xs: 'flex', md: 'flex' } }}>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
            }}
          >
            <Logo width="200vh" src={PageLogo} />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
                <MenuItem component={NavLink} to='/'>Home</MenuItem>
                <MenuItem component={HashLink} to='/#allpavilions'>All Pavilions</MenuItem>
                <MenuItem component={NavLink} to='/plans'>Launch My Pavilion</MenuItem>
                <MenuItem component={NavLink} to='/plans'>HowTo Videos</MenuItem>
                <MenuItem component={NavLink} to='/privacypolicy'>Privacy Policy</MenuItem>
                <MenuItem component={NavLink} to='/contact'>Contact</MenuItem>
              
            </Menu>
          </Box>
          <Typography
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
            }}
          >
             <Logo width="150vh" src={PageLogo} />
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent:'center' }}>
              <RedButton variant="link" style={
                    isActive('#allpavilions') ? { color:'gray', border: '0', } : { }}   
                    component={NavLink} to='/'>HOME</RedButton>
              <RedButton  style={isActive('#allpavilions') ? {
                             color: '#e30613',              
                             border: '1px solid rgba(255, 0, 17, 0.5)',
                             borderStyle: 'hidden hidden solid hidden' ,
                      } : {} } 
                 variant="link"   component={HashLink} to='/#allpavilions'>ALL PAVILIONS</RedButton>
              <RedButton variant="link" className={({ isActive }) => (isActive ? 'active' : '')}  component={NavLink} to='/plans'>LAUNCH MY PAVILION</RedButton>
              <RedButton variant="link" className={({ isActive }) => (isActive ? 'active' : '')}  component={NavLink} to='https://www.youtube.com/channel/UCpvImeYUgu-UAHyjRKDaPTA' target='_blank'>HOWTO VIDEOS</RedButton>
              <RedButton variant="link" className={({ isActive }) => (isActive ? 'active' : '')}  component={NavLink} to='/privacypolicy'>PRIVACY POLICY</RedButton>
              <RedButton variant="link" className={({ isActive }) => (isActive ? 'active' : '')}  component={NavLink} to='/contact'>CONTACT</RedButton>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <NavLink to="javascript:void(0);" onClick={handleDarkMode} className="btn btn-outline-mode btn-sm font-weight-bold d-flex align-items-center" id="theme-toggler" >
              {isIconClicked ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
            </NavLink>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NaviBar;